// extracted by mini-css-extract-plugin
module.exports = {"notificationPreferences":"_1p8r7l","row":"_3dt4Ae","label":"_3CTM79","checkbox":"qW4fF5"};